// balloonPumpGameSlice.js
import { createSlice } from '@reduxjs/toolkit'
import { getMyBets, getTopBets } from './footballGame.thunk'

const initialState = {
  myBetsData: [],
  topBetsData: [],
  topBetsLoading: false,
  myBetsLoading: false
}

const footballGame = createSlice({
  name: 'footballGame',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMyBets.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true

        }
      })
      .addCase(getMyBets.rejected, (state, action) => {
        return {
          ...state,
          myBetsData: initialState.myBetsData,
          myBetsLoading: false

        }
      })
      .addCase(getMyBets.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload,
          myBetsLoading: false
        }
      })
      .addCase(getTopBets.pending, (state, action) => {
        return {
          ...state,
          topBetsLoading: true
        }
      })
      .addCase(getTopBets.fulfilled, (state, action) => {
        return {
          ...state,
          topBetsData: action.payload,
          topBetsLoading: false
        }
      })
      .addCase(getTopBets.rejected, (state, action) => {
        return {
          ...state,
          topBetsData: [],
          topBetsLoading: false
        }
      })
  }
})

export const { setSelectedAmount, setCurrentScore, setIsHolding, setBetLock } = footballGame.actions
export default footballGame.reducer
